import { parse, stringify } from 'query-string';
import { ORDER_CANDIDATES } from '../define/consts/solution';
import { isEmpty } from './common';
import { safeJsonParse } from './query';
/**
 * パラメータから検索で使用する項目の一覧を取得する
 * @param params
 * @returns {{}}
 */
const parseParams = (params) => {
    const larges = [];
    const middles = [];
    const region = [];
    const acceptance = [];
    const tag = [];
    let organization = null;
    let order = ORDER_CANDIDATES[0].value;
    // チェックボックスの値の改修
    Object.keys(params).forEach((key) => {
        if (params[key] !== true) {
            return;
        }
        if (key.indexOf('large_') === 0) {
            larges.push(key.replace('large_', ''));
        }
        else if (key.indexOf('middle_') === 0) {
            middles.push(key.replace('middle_', ''));
        }
        else if (key.indexOf('region_') === 0) {
            region.push(key.replace('region_', ''));
        }
        else if (key.indexOf('acceptance_') === 0) {
            acceptance.push(key.replace('acceptance_', ''));
        }
        else if (key.indexOf('tag_') === 0) {
            tag.push(key.replace('tag_', ''));
        }
    });
    // 組織指定
    const organizationId = params.organization;
    if (['string', 'number'].includes(typeof organizationId) &&
        isEmpty(organizationId)) {
        organization = organizationId;
    }
    // ソート
    const orderId = params.order;
    if (orderId) {
        order = orderId;
    }
    // 金額
    const priceGte = params.price_gte;
    const priceLte = params.price_lte;
    return {
        acceptance,
        larges,
        middles,
        order,
        organization,
        price_gte: priceGte,
        price_lte: priceLte,
        region,
        tag,
    };
};
/**
 * query stringの値を検索で使用するパラメータの値に変換する
 * @param qs
 */
export const queryToStates = (qs) => {
    const params = {};
    const qsParams = parse(qs);
    safeJsonParse(qsParams.large_category).forEach((v) => {
        params[`large_${v}`] = true;
    });
    safeJsonParse(qsParams.middle_category).forEach((v) => {
        params[`middle_${v}`] = true;
    });
    safeJsonParse(qsParams.region).forEach((v) => {
        params[`region_${v}`] = true;
    });
    safeJsonParse(qsParams.acceptance).forEach((v) => {
        params[`acceptance_${v}`] = true;
    });
    safeJsonParse(qsParams.tag).forEach((v) => {
        params[`tag_${v}`] = true;
    });
    // organization
    params.organization = qsParams.organization;
    if (typeof params.organization !== 'string' || isEmpty(params.organization)) {
        params.organization = '';
    }
    // order
    params.order = qsParams.order || '';
    // price
    const priceLte = parseInt(qsParams.price_lte, 10);
    if (priceLte && priceLte > 0) {
        params.price_lte = priceLte;
    }
    const priceGte = parseInt(qsParams.price_gte, 10);
    if (priceGte && priceGte > 0) {
        params.price_gte = priceGte;
    }
    return params;
};
/**
 * 検索で使用したパラメータをquery stringの構成用のパーツにする
 * @param params
 */
export const statesToSearch = (params) => {
    const query = {};
    const { acceptance, larges, middles, order, organization, price_gte: priceGte, price_lte: priceLte, region, tag, } = parseParams(params);
    if (larges.length > 0) {
        query.large_category = JSON.stringify(larges);
    }
    if (middles.length > 0) {
        query.middle_category = JSON.stringify(middles);
    }
    if (region.length > 0) {
        query.region = JSON.stringify(region);
    }
    if (acceptance.length > 0) {
        query.acceptance = JSON.stringify(acceptance);
    }
    if (tag.length > 0) {
        query.tag = JSON.stringify(tag);
    }
    if (organization > 0) {
        query.organization = parseInt(organization, 10);
    }
    query.order = order;
    if (priceGte > 0) {
        query.price_gte = priceGte;
    }
    if (priceLte > 0) {
        query.price_lte = priceLte;
    }
    return query;
};
/**
 * objectをURL用のquery stringに変換する
 * @param params
 * @returns {string|*}
 */
export const toQuery = (params) => stringify(params);
/**
 * 大カテゴリIDを検索のURL用のquery stringに変換する
 * @param id
 * @returns {string|*}
 */
export const largeToQuery = (id) => toQuery({ large_category: JSON.stringify([id]) });
/**
 * 中カテゴリIDを検索のURL用のquery stringに変換する
 * @param ids
 * @returns {string|*}
 */
export const middleToQueries = (ids) => toQuery({ middle_category: JSON.stringify(ids) });
/**
 * 検索で使用したパラメータをquery stringの構成用のパーツにし、query stringの文字列にする
 * @param params
 * @returns {string|*}
 */
export const statesToQuery = (params) => toQuery(statesToSearch(params));
